import { BCollapse } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBCollapse when migrating. */
export const EgBCollapse = createEgBootstrapProxy("EgBCollapse", BCollapse);
